<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{!form.controls.id.value ? 'Add Product Service' : 'Edit Product Service'}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()">
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form" novalidate>
        <div class="row">
            <div class="form-group col-md-4">
                <label>Fuel Specification</label>
                <input class="form-control" formControlName="fuel_specification"
                       [ngClass]="getFormGroupErrorClasses(form.controls.fuel_specification)"
                       placeholder="Fuel Specification...">
                <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.fuel_specification)">
                    <p *ngIf="form.controls.fuel_specification.errors.required">Fuel Specification field is required</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>
            <div class="form-group col-md-4">
                <label>Delivery Point</label>
                <select class="form-control" formControlName="delivery_point">
                    <option value="" disabled [selected]="!form.controls.delivery_point.value">Select...</option>
                    <option *ngFor='let item of deliveryPoints' [value]="item.id">{{ item.name }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.delivery_point)">
                    <p *ngIf="form.controls.delivery_point.errors.required">Delivery Point field is required</p>
                </div>
            </div>
            <div class="form-group col-md-4">
                <label>Iata service level</label>
                <select class="form-control" formControlName="iata_service_level">
                    <option value="" [selected]="!form.controls.iata_service_level.value">Select...</option>
                    <option *ngFor='let item of iataServiceLevels' [value]="item.id">{{ item.name }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.iata_service_level)">
                    <p *ngIf="form.controls.iata_service_level.errors.required">Iata service level field is required</p>
                </div>
            </div>
            <div class="form-group col-md-4">
                <label>Operating hours</label>
                <input class="form-control" formControlName="operating_hours"
                       [ngClass]="getFormGroupErrorClasses(form.controls.operating_hours)"
                       placeholder="Operating hours...">
                <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.operating_hours)">
                    <p *ngIf="form.controls.operating_hours.errors.required">Operating hours field is required</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>

            <div class="form-group col-md-4">
                <label>Refueler Company Code</label>
                <select class="form-control" formControlName="refueler_company_code">
                    <option value="" [selected]="!form.controls.refueler_company_code.value">Select...</option>
                    <option *ngFor='let item of refuelerCompanyCodes' [value]="item.id">{{ item.name }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.refueler_company_code)">
                    <p *ngIf="form.controls.refueler_company_code.errors.required">Iata service level field is required</p>
                </div>
            </div>

            <div class="form-group col-md-4">
                <label>Title Transfer</label>
                <input class="form-control" formControlName="title_transfer"
                       [ngClass]="getFormGroupErrorClasses(form.controls.title_transfer)"
                       placeholder="Title Transfer...">
                <div class="invalid-feedback" *ngIf="showErrorBlock(form.controls.title_transfer)">
                    <p *ngIf="form.controls.title_transfer.errors.required">Title Transfer field is required</p>
                </div>
                <small class="form-text text-muted"></small>
            </div>

            <div class="form-group col-md-4">
                <label>Comments</label>
                <textarea class="form-control" rows="3" formControlName="comments"
                    [ngClass]="getFormGroupErrorClasses(form.controls.comments)">
                </textarea>
            </div>

        </div>
    </form>
</div>
<div class="modal-footer">
    <button class="btn btn-light" (click)="close()">Close</button>
    <jft-submit-button
        (onClick)="submit()"
        [loading]="form.disabled"
        [class]="'btn btn-outline-primary'"
        [disabled]="form.invalid"
        [ngbPopover]="getFirstFormGroupErrorLabel(form)"
        triggers="mouseenter:mouseleave"
        placement="left"
        [title]="'Save'"
        [loadingTitle]="'Saving'" triggers="mouseenter:mouseleave" placement="right">
    </jft-submit-button>
</div>
